import React from 'react';
import './WsjtxQsoModal.css';

function WsjtxQsoModal({ qso, defaults, onConfirm, onDismiss }) {
  if (!qso) {
    return null;
  }

  return (
    <div className="wsjtx-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="wsjtx-qso-title">
      <div className="wsjtx-modal">
        <h3 id="wsjtx-qso-title">Log WSJT-X QSO?</h3>
        <dl className="wsjtx-qso-details">
          <div><dt>Callsign</dt><dd>{qso.callsign || '—'}</dd></div>
          <div><dt>Band</dt><dd>{qso.frequency || '—'}</dd></div>
          <div><dt>Mode</dt><dd>{qso.mode || 'Digital'}</dd></div>
          {qso.rstSent && <div><dt>RST sent</dt><dd>{qso.rstSent}</dd></div>}
          {qso.rstRcvd && <div><dt>RST rcvd</dt><dd>{qso.rstRcvd}</dd></div>}
          {qso.grid && <div><dt>Grid</dt><dd>{qso.grid}</dd></div>}
        </dl>
        <p className="wsjtx-modal-note">
          Exchange fields will use your logger values
          {defaults?.classSent ? ` (${defaults.classSent}` : ''}
          {defaults?.locationReceived ? ` / ${defaults.locationReceived}` : ''}
          {defaults?.classSent || defaults?.locationReceived ? ')' : ' if set'}.
        </p>
        <div className="wsjtx-modal-actions">
          <button type="button" className="btn-wsjtx-primary" onClick={onConfirm}>
            Log contact
          </button>
          <button type="button" className="btn-wsjtx-secondary" onClick={onDismiss}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}

export default WsjtxQsoModal;
